import React, { Component } from "react";

import { CButton, CCard, CCardBody, CTooltip } from "@coreui/react";
import {
  AiOutlineCheckCircle,
  AiOutlineCloseCircle,
  AiOutlineWarning,
  AiOutlineFileExcel,
  AiOutlineUpload
} from "react-icons/ai";
import { connect } from "react-redux";
import { toastr } from "react-redux-toastr";
import {
  Input,
  FormGroup,
  FormText,
  Label,
  Modal,
  ModalBody,
  ModalHeader
} from "reactstrap";
import { bindActionCreators } from "redux";

import { logout } from "../../../actions/baseActions";
import { setObj } from "../../../actions/noteActions";
import imgImport from "../../../assets/imgs/import/import_icon.png";
import NoData from "../../../assets/imgs/no_data.svg";
import Breadcrumb from "../../../components/Breadcrumb";
import Loading from "../../../components/Loading";
import ProtectedRoute from "../../../components/ProtectedRoute";
import URL from "../../../config/api";
import axios from "../../../config/axios";

import "./style.css";

class Import extends Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: true,
      sent: [],
      group: this.props.general.active_roles.group_id,
      processing: null,
      file: null,
      dragging: false,
      error: "",
      showModal: false,
      getError: false,
      dataError: [],
      dataSuccess: [],
      onSending: false,
      totalLineErrors: 0,
      totalLines: 0,
      nameSheet: "",
      message: "",
      importedCount: 0,
      summary: {}
    };

    this.fileInputRef = React.createRef();
  }

  getSerieAbbreviation = serieName => {
    const serieMap = {
      "4º Série EM": "E4",
      "EJA FASE 4": "J4",
      "EJA FASE 3": "J3",
      "EJA FASE 2": "J2",
      "EJA FASE 1": "J1",
      "3º Série EM": "E3",
      "2º Série EM": "E2",
      "1º Série EM": "E1",
      "9º Ano EF": "F9",
      "8º Ano EF": "F8",
      "7º Ano EF": "F7",
      "6º Ano EF": "F6",
      "5º Ano EF": "F5",
      "4º Ano EF": "F4",
      "3º Ano EF": "F3",
      "2º Ano EF": "F2",
      "1º Ano EF": "F1",
      "5 anos": "P2",
      "4 anos": "P1",
      "3 anos": "M2",
      "2 anos": "M1",
      "Berçário 2": "B2",
      "Berçário 1": "B1"
    };

    return serieMap[serieName] || serieName;
  };

  componentDidMount() {
    if (
      this.props.general.active_roles.group_id === 45 ||
      this.props.general.active_roles.group_id === 92
    ) {
      this.props.history.push("/home");
      return;
    }

    this.props.setObj(16, this.props.currentRoute, this.props.currentRoute);
    this.handleSentFiles();
    this.changeBackgroundColor();
  }

  handleDragOver = e => {
    e.preventDefault();
    this.setState({ dragging: true });
  };

  handleDragLeave = () => {
    this.setState({ dragging: false });
  };

  handleSentFiles() {
    this.setState({ loading: true });
    axios
      .get(`${URL.api}import/sent`, {
        headers: { Authorization: `Bearer ${this.props.user.token}` }
      })
      .then(
        resp => {
          const newSent = resp.data.data.sort(this.sortFiles);
          this.setState({
            sent: newSent,
            loading: false
          });
        },
        error => {
          this.error(error.response.statusText);
          this.setState({ loading: false });
        }
      );
  }

  sortFiles = (a, b) =>
    // Método para ordenar arquivos
    new Date(b.created_at) - new Date(a.created_at);

  handleInputChange = e => {
    const selectedFile = e.target.files[0];
    if (selectedFile && selectedFile.name.endsWith(".xlsx")) {
      this.setState({ file: selectedFile, error: "" }, () => {
        this.onFilesAdded();
      });
    } else {
      this.setState({
        error: "Arquivo incompatível. Por favor envie um arquivo do tipo xlsx."
      });
      toastr.error(
        "Arquivo incompatível",
        "Por favor envie um arquivo do tipo xlsx."
      );
    }
  };

  handleDrop = e => {
    e.preventDefault();
    this.setState({ dragging: false });

    const droppedFile = e.dataTransfer.files[0];

    if (droppedFile && droppedFile.name.endsWith(".xlsx")) {
      this.setState({ file: droppedFile, error: "" });
      this.fileInputRef.current.files = e.dataTransfer.files;

      setTimeout(() => {
        this.onFilesAdded();
      }, 100);
    } else {
      this.setState({
        error: "Arquivo incompatível. Por favor envie um arquivo do tipo xlsx."
      });
      toastr.error(
        "Arquivo incompatível",
        "Por favor envie um arquivo do tipo xlsx."
      );
    }
  };

  handleCancel = () => {
    this.clearFileInput();
    this.setState(prevState => ({
      file: null,
      error: "",
      onSending: false
    }));
  };

  // Método para remover o arquivo após processamento (seja sucesso ou erro)
  removeProcessedFile = async filename => {
    if (!filename) return;

    try {
      await axios.post(
        `${URL.api}import/delete`,
        { name: filename },
        {
          headers: { Authorization: `Bearer ${this.props.user.token}` }
        }
      );
      // Atualiza a lista (agora vazia)
      this.handleSentFiles();
    } catch (error) {
      console.error("Erro ao remover arquivo:", error);
      // Mesmo com erro na remoção, continua o fluxo
    }
  };

  removeSent = filename => {
    axios
      .post(
        `${URL.api}import/delete`,
        { name: filename },
        {
          headers: {
            Authorization: `Bearer ${this.props.user.token}`
          }
        }
      )
      .then(
        resp => {
          this.setState(prevState => ({
            sent: prevState.sent.filter(item => item.original_name !== filename)
          }));
          this.handleSentFiles();
        },
        error => {
          this.error(error.response.statusText);
        }
      );
  };

  onFilesAdded = () => {
    if (this.state.onSending) return;

    this.setState(
      prevState => {
        let files;
        if (prevState.file) {
          files = [prevState.file];
        } else if (this.fileInputRef.current?.files?.length) {
          files = Array.from(this.fileInputRef.current.files).filter(file =>
            file.name.endsWith(".xlsx")
          );
        } else {
          return {};
        }

        if (files.length === 0) {
          toastr.warning("Atenção", "Nenhum arquivo válido para enviar");
          return {};
        }

        return { onSending: true };
      },
      () => {
        const files = this.state.file
          ? [this.state.file]
          : Array.from(this.fileInputRef.current.files).filter(file =>
              file.name.endsWith(".xlsx")
            );

        if (files.length === 0) return;

        const formData = new FormData();
        for (let i = 0; i < files.length; i++) {
          formData.append(`file${i}`, files[i]);
        }

        axios
          .post(`${URL.api}import/send`, formData, {
            headers: {
              "Content-Type": "multipart/form-data",
              Authorization: `Bearer ${this.props.user.token}`
            }
          })
          .then(
            resp => {
              this.setState(
                prevState => ({
                  onSending: false,
                  file: null,
                  error: "",
                  dragging: false
                }),
                () => {
                  this.handleSentFiles();
                  toastr.success("Sucesso", "Planilha enviada com sucesso!");
                }
              );
            },
            error => {
              this.error(error.response.statusText);
              this.clearFileInput();
              this.setState({
                onSending: false,
                file: null,
                error: "",
                dragging: false
              });
            }
          );
      }
    );
  };

  handleCloseModal = () => {
    this.resetScreen();
  };

  formatPartialErrors = errors => {
    if (!errors || !Array.isArray(errors)) return [];

    return errors.map(error => {
      if (typeof error === "string") {
        const match = error.match(/Linha (\d+):\s*(.+)/);
        if (match) {
          return {
            line: match[1],
            error: match[2]
          };
        }
        return {
          line: "N/A",
          error
        };
      }
      return error;
    });
  };

  formatErrors = errorData => {
    if (!errorData) return [];

    if (Array.isArray(errorData) && errorData[0]?.line) {
      return errorData;
    }

    if (Array.isArray(errorData.erros)) {
      return this.formatPartialErrors(errorData.erros);
    }

    // Formato: processing_errors
    if (Array.isArray(errorData.processing_errors)) {
      return errorData.processing_errors.map(err => ({
        line: err.line || "N/A",
        matricula: err.matricula || "N/A",
        name: err.name || "N/A",
        error: err.error || "Erro desconhecido"
      }));
    }

    // Formato: validation_errors
    if (errorData.validation_errors) {
      const errors = [];
      Object.entries(errorData.validation_errors).forEach(
        ([field, messages]) => {
          errors.push({
            line: "N/A",
            error: `${field}: ${
              Array.isArray(messages) ? messages.join(", ") : messages
            }`
          });
        }
      );
      return errors;
    }

    // Formato: erro simples
    if (errorData.error) {
      return [
        {
          line: "N/A",
          error: errorData.error
        }
      ];
    }

    return [];
  };

  processFiles = async () => {
    if (!this.state.sent.length) {
      toastr.warning("Atenção", "Para continuar, importe alguma planilha");
      return;
    }

    const stateData = this.props.location?.state || {};
    const roomId = stateData.room_id;
    const serieName = stateData.serie_abbreviation;
    const serieAbbreviation = this.getSerieAbbreviation(serieName);
    const groupId = stateData.group_id;

    if (!roomId) {
      toastr.error("Erro", "Dados da turma não encontrados");
      return;
    }

    // 🔥 Guarda o nome do arquivo ANTES de processar
    const fileName = this.state.sent[0]?.original_name;

    this.setState(prevState => ({
      processing: prevState.sent[0]?.original_name || null,
      showModal: false
    }));

    let file;

    try {
      file = this.state.sent[0];

      const resp = await axios.post(
        `${URL.api}import/process-and-enroll`,
        {
          filename: file.original_name,
          group_id: groupId || this.state.group,
          room_id: roomId,
          serie_abbreviation: serieAbbreviation
        },
        {
          headers: {
            Authorization: `Bearer ${this.props.user.token}`,
            "Content-Type": "application/json"
          },
          timeout: 300000
        }
      );

      if (resp.data.success === true) {
        this.setState({
          processing: null,
          showModal: true,
          getError: false,
          message: resp.data.message || "✅ Importação realizada com sucesso!",
          dataSuccess: resp.data.data?.students || [],
          summary: resp.data.data?.summary || {},
          nameSheet: file.original_name,
          totalLines: resp.data.data?.total_processed || 0,
          importedCount:
            resp.data.data?.imported_count ||
            resp.data.data?.students?.length ||
            0,
          dataError: [],
          totalLineErrors: 0
        });
      } else if (
        resp.data.success === false &&
        resp.data.resumo?.importados > 0
      ) {
        this.setState({
          processing: null,
          showModal: true,
          getError: true,
          message: resp.data.message || "⚠️ Importação parcialmente concluída",
          dataError: this.formatPartialErrors(resp.data.erros),
          dataSuccess: [],
          summary: resp.data.resumo || {},
          nameSheet: file.original_name,
          totalLines: resp.data.resumo?.total || 0,
          importedCount: resp.data.resumo?.importados || 0,
          totalLineErrors:
            resp.data.resumo?.com_erro || resp.data.erros?.length || 0
        });
      } else if (resp.data.imported_count > 0) {
        this.setState({
          processing: null,
          showModal: true,
          getError: true,
          message: resp.data.message || "⚠️ Importação parcialmente concluída",
          dataError: resp.data.processing_errors || resp.data.errors || [],
          dataSuccess: resp.data.imported_students || [],
          summary: resp.data.summary || resp.data.resumo || {},
          nameSheet: file.original_name,
          totalLines: resp.data.summary?.total || resp.data.resumo?.total || 0,
          importedCount:
            resp.data.imported_count || resp.data.resumo?.importados || 0,
          totalLineErrors:
            resp.data.processing_errors?.length || resp.data.errors?.length || 0
        });
      } else {
        this.setState({
          processing: null,
          showModal: true,
          getError: true,
          message: resp.data.message || "❌ Ocorreu um erro na importação",
          dataError: this.formatErrors(resp.data),
          dataSuccess: [],
          summary: resp.data.summary || resp.data.resumo || {},
          nameSheet: file.original_name,
          totalLines: resp.data.summary?.total || resp.data.resumo?.total || 0,
          importedCount: 0,
          totalLineErrors: this.formatErrors(resp.data).length
        });
      }
    } catch (error) {
      if (
        error.response &&
        error.response.status === 422 &&
        error.response.data
      ) {
        const apiData = error.response.data;
        const currentFileName = file
          ? file.original_name
          : this.state.sent[0]?.original_name || "";

        if (apiData.resumo?.importados > 0 || apiData.imported_count > 0) {
          this.setState({
            processing: null,
            showModal: true,
            getError: true,
            message: apiData.message || "⚠️ Importação parcialmente concluída",
            dataError: this.formatPartialErrors(apiData.erros) || [],
            dataSuccess: apiData.imported_students || [],
            summary: apiData.resumo || apiData.summary || {},
            nameSheet: currentFileName,
            totalLines: apiData.resumo?.total || apiData.summary?.total || 0,
            importedCount:
              apiData.resumo?.importados || apiData.imported_count || 0,
            totalLineErrors:
              apiData.resumo?.com_erro || apiData.erros?.length || 0
          });
        } else {
          this.setState({
            processing: null,
            showModal: true,
            getError: true,
            message: apiData.message || "❌ Erro na importação",
            dataError: this.formatErrors(apiData),
            dataSuccess: [],
            summary: apiData.resumo || apiData.summary || {},
            nameSheet: currentFileName,
            totalLines: apiData.resumo?.total || apiData.summary?.total || 0,
            importedCount: 0,
            totalLineErrors: this.formatErrors(apiData).length
          });
        }
      } else {
        let errorMessage = "❌ Erro ao processar a importação";
        let errorDetails = [];

        const currentFileName = this.getFileName(file);

        if (error.response) {
          errorMessage = `Erro ${error.response.status}: ${error.response.statusText}`;
          errorDetails = this.formatErrors(error.response.data);
        } else if (error.request) {
          errorMessage = "🌐 Erro de conexão. Verifique sua internet.";
        } else {
          errorMessage = "⚙️ Erro ao configurar a requisição";
        }

        this.setState({
          processing: null,
          showModal: true,
          getError: true,
          message: errorMessage,
          dataError: errorDetails,
          dataSuccess: [],
          totalLineErrors: errorDetails.length,
          totalLines: 0,
          importedCount: 0,
          summary: {},
          nameSheet: currentFileName
        });
      }
    } finally {
      // 🔥 GARANTIA: SEMPRE será executado, mesmo com erro!
      // Remove o arquivo seja qual for o resultado (sucesso, erro parcial, erro completo)
      await this.removeProcessedFile(fileName);
    }
  };

  // Adicionar este método auxiliar
  getFileName = file =>
    file?.original_name || this.state.sent[0]?.original_name || "";

  clearFileInput = () => {
    if (this.fileInputRef.current) {
      this.fileInputRef.current.value = "";
    }
  };

  handleDropzoneClick = () => {
    if (this.state.file) {
      return;
    }

    if (this.state.onSending) {
      return;
    }

    this.fileInputRef.current.click();
  };

  error = response => {
    if (response === "Unauthorized") {
      this.props.logout(this.props.user.token);
    } else {
      toastr.error("Fail", response);
    }
  };

  handleDownload = () => {
    const link = document.createElement("a");
    const urlLink =
      "https://back.educandus.com.br/uploads/sheets/1724873099-importacao_alunos.xlsx";
    link.href = urlLink;
    link.download = "importacao_de_alunos_educandus.xlsx";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  changeBackgroundColor = () => {
    const container = document.querySelector(".container-fluid");
    if (container) {
      container.style.backgroundColor = "#F0F4F8";
    }
  };

  resetScreen = () => {
    this.clearFileInput();

    this.setState(
      prevState => ({
        file: null,
        dragging: false,
        error: "",
        onSending: false,
        processing: null,
        sent: [],
        getError: false,
        dataError: [],
        totalLineErrors: 0,
        totalLines: 0,
        nameSheet: "",
        showModal: false
      }),
      () => {
        this.handleSentFiles();
      }
    );
  };

  render() {
    const { loading, sent, dragging, file, error, processing, onSending } =
      this.state;

    const shouldShowUploadSection = !onSending && sent.length === 0;

    return (
      <>
        <Breadcrumb
          current={this.props.currentRoute}
          items={[{ path: "/classroom/list", to: "/classroom/list" }]}
        />
        <div className="w-100 rounded">
          <CCard>
            {this.state.showModal && (
              <Modal
                isOpen={this.state.showModal}
                toggle={null}
                className={null}
                size="lg"
                backdrop="static"
              >
                <ModalHeader style={{ border: "none" }}>
                  <div className="header-import">
                    <button
                      type="button"
                      className="close"
                      data-dismiss="modal"
                      aria-label="Close"
                      onClick={this.handleCloseModal}
                    >
                      <span aria-hidden="true">&times;</span>
                    </button>
                  </div>
                </ModalHeader>
                <ModalBody>
                  <div className="import-students-modal-body">
                    {!this.state.getError ? (
                      <>
                        <AiOutlineCheckCircle
                          style={{ fontSize: "100px", color: "#7ab213" }}
                        />
                        <span
                          style={{ fontSize: "25px", marginBottom: "10px" }}
                        >
                          {this.state.message || "Sucesso!"}
                        </span>

                        <div className="d-flex flex-column align-items-center w-100 mt-3">
                          <div className="alert alert-success w-100">
                            <strong>📊 Resumo da Importação:</strong>
                            <div className="mt-2">
                              <div>
                                ✅ <strong>{this.state.importedCount}</strong>{" "}
                                aluno(s) importado(s) com sucesso
                              </div>
                              <div>📁 Arquivo: {this.state.nameSheet}</div>
                              <div>
                                🏫 Turma:{" "}
                                {this.state.summary?.room?.name || "N/A"}
                              </div>
                              <div>
                                📚 Série: {this.state.summary?.serie || "N/A"}
                              </div>
                              <div>
                                🕒 Data:{" "}
                                {this.state.summary?.timestamp ||
                                  new Date().toLocaleDateString()}
                              </div>
                            </div>
                          </div>

                          {this.state.dataSuccess.length > 0 && (
                            <div className="import-students-container-table mt-3 w-100">
                              <h6>📋 Alunos Importados:</h6>
                              <table
                                border="1"
                                cellPadding="10"
                                className="w-100"
                              >
                                <thead>
                                  <tr>
                                    <th>Linha</th>
                                    <th>Nome</th>
                                    <th>Login</th>
                                    <th>Status</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {this.state.dataSuccess.map(
                                    (student, index) => (
                                      <tr key={index}>
                                        <td>{student.line_number}</td>
                                        <td>{student.name}</td>
                                        <td>{student.username}</td>
                                        <td>
                                          <span className="text-success">
                                            ✅ Importado
                                          </span>
                                        </td>
                                      </tr>
                                    )
                                  )}
                                </tbody>
                              </table>
                            </div>
                          )}
                        </div>

                        <br />
                        <CButton
                          color="primary"
                          onClick={this.handleCloseModal}
                        >
                          Fechar
                        </CButton>
                      </>
                    ) : (
                      <>
                        {this.state.importedCount > 0 ? (
                          <>
                            <AiOutlineWarning
                              style={{ fontSize: "100px", color: "#e2d80b" }}
                            />
                            <span
                              style={{ fontSize: "25px", marginBottom: "10px" }}
                            >
                              ⚠️ Importação Parcial
                            </span>

                            <div className="alert alert-warning w-100 mt-3">
                              <strong>{this.state.message}</strong>
                              <div className="mt-2">
                                <div>
                                  ✅ <strong>{this.state.importedCount}</strong>{" "}
                                  aluno(s) importado(s)
                                </div>
                                <div>
                                  ❌{" "}
                                  <strong>{this.state.totalLineErrors}</strong>{" "}
                                  erro(s) encontrado(s)
                                </div>
                                <div>📁 Arquivo: {this.state.nameSheet}</div>
                              </div>
                            </div>
                          </>
                        ) : (
                          <>
                            <AiOutlineCloseCircle
                              style={{ fontSize: "100px", color: "#d11b0a" }}
                            />
                            <span
                              style={{ fontSize: "25px", marginBottom: "10px" }}
                            >
                              ❌ Erro na Importação
                            </span>

                            <div className="alert alert-danger w-100 mt-3">
                              <strong>{this.state.message}</strong>
                              <div className="mt-2">
                                <div>❌ Nenhum aluno importado</div>
                                <div>
                                  ❌{" "}
                                  <strong>{this.state.totalLineErrors}</strong>{" "}
                                  erro(s) encontrado(s)
                                </div>
                                <div>📁 Arquivo: {this.state.nameSheet}</div>
                              </div>
                            </div>
                          </>
                        )}

                        <p className="mt-3">
                          {this.state.importedCount > 0
                            ? "Alguns alunos foram importados com sucesso. Verifique os erros abaixo e corrija o arquivo para importar os demais."
                            : "Corrija os erros abaixo e tente novamente. Caso o problema persista, abra um chamado para assistência."}
                        </p>

                        <div className="d-flex justify-content-start flex-column align-items-start w-100 mt-3">
                          <span>
                            📊 Total: {this.state.totalLines} linha(s) | ✅
                            Sucesso: {this.state.importedCount} | ❌ Erros:{" "}
                            {this.state.totalLineErrors}
                          </span>
                        </div>

                        {this.state.dataError.length > 0 && (
                          <div className="import-students-container-table mt-3">
                            <h6>📋 Detalhes dos Erros:</h6>
                            <table
                              border="1"
                              cellPadding="10"
                              className="w-100"
                            >
                              <thead>
                                <tr>
                                  <th style={{ width: "10%" }}>Linha</th>
                                  <th style={{ width: "20%" }}>Matrícula</th>
                                  <th style={{ width: "30%" }}>Nome</th>
                                  <th style={{ width: "40%" }}>Erro</th>
                                </tr>
                              </thead>
                              <tbody>
                                {this.state.dataError.map((error, index) => (
                                  <tr key={index}>
                                    <td>{error.line || error.numero_linha}</td>
                                    <td>{error.matricula || "N/A"}</td>
                                    <td>{error.name || error.nome || "N/A"}</td>
                                    <td className="text-danger">
                                      {error.error || error.message}
                                    </td>
                                  </tr>
                                ))}
                              </tbody>
                            </table>
                          </div>
                        )}

                        {this.state.dataSuccess.length > 0 && (
                          <div className="import-students-container-table mt-3">
                            <h6>✅ Alunos Importados com Sucesso:</h6>
                            <table
                              border="1"
                              cellPadding="10"
                              className="w-100"
                            >
                              <thead>
                                <tr>
                                  <th>Linha</th>
                                  <th>Nome</th>
                                  <th>Login</th>
                                  <th>Status</th>
                                </tr>
                              </thead>
                              <tbody>
                                {this.state.dataSuccess.map(
                                  (student, index) => (
                                    <tr key={index}>
                                      <td>{student.line_number}</td>
                                      <td>{student.name}</td>
                                      <td>{student.username}</td>
                                      <td>
                                        <span className="text-success">
                                          ✅ Importado
                                        </span>
                                      </td>
                                    </tr>
                                  )
                                )}
                              </tbody>
                            </table>
                          </div>
                        )}

                        <div className="mt-4">
                          <CButton
                            color="primary"
                            onClick={this.handleCloseModal}
                          >
                            Fechar
                          </CButton>
                        </div>
                      </>
                    )}
                  </div>
                </ModalBody>
              </Modal>
            )}

            <CCardBody className="import-body p-2.5 overflow-auto">
              <section>
                <h5>Como importar seus estudantes</h5>
                <hr />
                <p>
                  Agora, cada turma tem o seu próprio botão de Importar
                  Estudantes. Isso significa que, ao importar uma planilha, os
                  estudantes serão cadastrados e adicionados diretamente na
                  turma.
                </p>
                <p>
                  A importação de estudantes possui três etapas: primeiro, você
                  baixa a planilha modelo e insere os dados dos seus estudantes;
                  segundo, <b>selecione ou arraste o arquivo</b> (o envio será
                  automático); por fim, você clica no botão de processar.
                </p>
                <p>
                  Caso seja informado algum erro leia com atenção e faça o que é
                  instruído.
                </p>
              </section>

              <section>
                <h6>Faça download da planilha modelo</h6>
                <hr />
                <div className="d-flex flex-column flex-md-row">
                  <div className="d-flex flex-column justify-content-center col-12 col-md-9">
                    <span className="mb-3">
                      Para importar seus estudantes a partir de uma planilha,
                      ela precisa estar{" "}
                      <b>no formato correto da planilha modelo</b> que
                      disponibilizamos.
                    </span>
                    <span className="mb-2">
                      Confira as <b>regras</b> abaixo e selecione a planilha:
                    </span>
                    <ul>
                      <li className="mb-1">
                        Formato permitido: <b>XLSX</b>
                      </li>
                      <li className="mb-1">
                        Tamanho máximo: <b>10 Mb</b>
                      </li>
                      <li className="mb-1">
                        Número de linhas ilimitado desde que não tenha uma{" "}
                        <b>linha em branco</b>
                      </li>
                    </ul>
                  </div>
                </div>
                <section className="p-3 border rounded-3 bg-light mb-4">
                  <div className="d-flex align-items-center gap-3 flex-wrap">
                    <img
                      src={imgImport}
                      alt="Download modelo"
                      style={{ width: "70px" }}
                    />
                    <div className="flex-grow-1">
                      <p className="mb-1 fw-semibold">
                        Baixe a planilha modelo para preencher corretamente os
                        dados dos estudantes.
                      </p>
                      <CButton
                        color="primary"
                        size="sm"
                        onClick={this.handleDownload}
                      >
                        <AiOutlineFileExcel size={18} className="me-1" />
                        Baixar modelo
                      </CButton>
                    </div>
                  </div>
                </section>
              </section>

              {shouldShowUploadSection && (
                <section>
                  <div className="container mt-3">
                    <FormGroup>
                      <Label for="exampleFile">
                        Selecione ou arraste a planilha para importar (envio
                        automático):
                      </Label>
                      <div
                        className={`dropzone ${dragging ? "dragging" : ""} ${
                          onSending ? "uploading" : ""
                        }`}
                        onDragOver={this.handleDragOver}
                        onDragLeave={this.handleDragLeave}
                        onDrop={this.handleDrop}
                        onClick={this.handleDropzoneClick}
                      >
                        <Input
                          id="exampleFile"
                          name="file"
                          type="file"
                          accept=".xlsx"
                          onChange={this.handleInputChange}
                          style={{ display: "none" }}
                          innerRef={this.fileInputRef}
                          disabled={onSending}
                        />
                        <p>
                          {file
                            ? `Arquivo selecionado: ${file.name} (envio automático em 1s)`
                            : "Arraste o arquivo .xlsx para cá ou clique para selecionar"}
                        </p>
                      </div>
                      {error && <p className="text-danger">{error}</p>}

                      <FormText>
                        O envio é automático após selecionar o arquivo. Para
                        importar uma nova planilha, primeiro conclua a
                        importação ou exclua a planilha atual.
                      </FormText>
                    </FormGroup>
                  </div>
                </section>
              )}

              {onSending && (
                <section>
                  <div className="container mt-3">
                    <div className="alert alert-info d-flex align-items-center">
                      <div
                        className="spinner-border spinner-border-sm me-3"
                        role="status"
                      >
                        <span className="visually-hidden">Carregando...</span>
                      </div>
                      <div>
                        <strong>Enviando arquivo...</strong>
                        <div className="small">
                          Aguarde enquanto enviamos sua planilha.
                        </div>
                        {file && (
                          <div className="small mt-1">
                            Arquivo: <strong>{file.name}</strong>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </section>
              )}

              <section>
                {sent.length > 0 ? (
                  <div className="w-100">
                    <div className="d-flex justify-content-between align-items-center mb-3">
                      <h6 className="mb-0">Arquivo pronto para processar</h6>
                    </div>

                    <div className="w-100">
                      <div className="d-none d-md-block">
                        <table className="table table-hover table-outline mb-0 w-100 mb-4">
                          <thead className="thead-light">
                            <tr>
                              <th>Arquivo</th>
                              <th>Data de criação</th>
                              <th>Ações</th>
                            </tr>
                          </thead>
                          <tbody>
                            {sent.map((item, index) => (
                              <tr key={index}>
                                <td>{item.name}</td>
                                <td>{item.created_at}</td>
                                <td>
                                  <CTooltip content="Apagar">
                                    <CButton
                                      color="danger"
                                      size="sm"
                                      onClick={() =>
                                        this.removeSent(item.original_name)
                                      }
                                    >
                                      <i className="fa fa-trash"></i>
                                    </CButton>
                                  </CTooltip>
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>

                      <div className="d-md-none">
                        {sent.map((item, index) => (
                          <CCard key={index} className="mb-3">
                            <CCardBody>
                              <div className="d-flex justify-content-between align-items-start">
                                <div>
                                  <strong>Arquivo:</strong>
                                  <div className="mb-2">{item.name}</div>

                                  <strong>Data de criação:</strong>
                                  <div>{item.created_at}</div>
                                </div>

                                <CTooltip content="Apagar">
                                  <CButton
                                    color="danger"
                                    size="sm"
                                    onClick={() =>
                                      this.removeSent(item.original_name)
                                    }
                                  >
                                    <i className="fa fa-trash"></i>
                                  </CButton>
                                </CTooltip>
                              </div>
                            </CCardBody>
                          </CCard>
                        ))}
                      </div>
                    </div>

                    <div className="alert alert-warning mt-3">
                      <small>
                        <strong>Próximo passo:</strong> Clique em "Processar"
                        para importar os estudantes da planilha para a turma.
                        Para enviar uma nova planilha, primeiro exclua a atual.
                      </small>
                    </div>
                  </div>
                ) : (
                  !onSending && (
                    <div className="mt-2 w-100 d-flex flex-column justify-content-center align-items-center">
                      <img
                        src={NoData}
                        style={{
                          height: "100px",
                          marginBottom: "1rem",
                          opacity: 0.5
                        }}
                        alt=""
                      />
                      <span>Nenhum arquivo a ser processado</span>
                      <small className="text-muted mt-2">
                        Selecione uma planilha para começar a importação
                      </small>
                    </div>
                  )
                )}
              </section>

              {sent.length > 0 && (
                <section className="d-flex justify-content-end mt-4">
                  {!processing ? (
                    <CButton
                      color="primary"
                      onClick={() => this.processFiles()}
                      disabled={sent.length === 0 || onSending}
                    >
                      <AiOutlineUpload className="me-2" />
                      Processar arquivo
                    </CButton>
                  ) : (
                    <Loading />
                  )}
                </section>
              )}
            </CCardBody>
          </CCard>
        </div>
        <ProtectedRoute routeId={this.props.currentRoute} />
      </>
    );
  }
}

// ADICIONAR ESTA FUNÇÃO QUE ESTAVA FALTANDO
const mapStateToProps = state => ({
  user: state.user,
  general: state.general,
  profile: state.profile
});

const mapDispatchToProps = dispatch =>
  bindActionCreators({ logout, setObj }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(Import);
